import '@/scss/page-templates/news.scss';

console.log('news.ts');

